import * as SliderPrimitive from "@radix-ui/react-slider";
import * as React from "react";
import { cn } from "../../../Utils/helper";

const Slider = React.forwardRef((props, ref) => {
  const { className, rangeStyle = {}, thumbStyle = {}, ...rest } = props;
  return (
    <SliderPrimitive.Root
      ref={ref}
      className={cn(
        "relative flex w-full touch-none select-none items-center cursor-pointer",
        className
      )}
      {...rest}
    >
      <SliderPrimitive.Track
        className="relative  w-full grow overflow-hidden rounded-full bg-gray-200/80 h-[2.5px]"
        onPointerDown={(e) => {
          const track = e.currentTarget;
          const rect = track.getBoundingClientRect();
          const x = e.clientX - rect.left;
          const percent = (x / rect.width) * 100;

          const newValue = Math.round(
            ((props.max || 100) - (props.min || 0)) * (percent / 100) +
              (props.min || 0)
          );

          props.onValueChange?.([newValue]);
        }}
      >
        <SliderPrimitive.Range
          className="absolute h-full rounded-full "
          style={{ ...rangeStyle }}
        />
      </SliderPrimitive.Track>

      <SliderPrimitive.Thumb
        className={cn(
          "block size-[30px] rounded-full bg-primary shadow-lg ring-0",
          "border-2 border-primary",
          "focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-primary/30",
          "disabled:pointer-events-none disabled:opacity-50",
          "data-[state=active]:scale-110"
        )}
        style={{ ...thumbStyle }}
      />

      <div
        className="absolute inset-0 -inset-y-4 -inset-x-2 pointer-events-none"
        style={{ zIndex: 10 }}
      />
    </SliderPrimitive.Root>
  );
});

Slider.displayName = "Slider";

export default Slider;
